import { Radio,Box, BoxTitle, Indication,InlineRight } from './styles';
import RadioButtonList, { RadioButtonListItem } from "../../../components/RadioButtonList";
import ActionBar from "../../../components/ActionBar";
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { RootState } from '../../../store/types';
import { serviceLoading } from 'common/loaderReducer';
import { CONNECT_DEALER_TO_ENGINE_API_REQUEST } from 'features/Dealers/ConnectByLabel/state/actionTypes';
import { connectDealerToEngineAPI,connectDealerCleanState, cleanSearchResults } from './state/actions';
import { parseLocationToRadioButtonListItems } from './state/utils';

const ResultsListingsBox = () => {
    const [businessAccountID, setbusinessAccountID] = React.useState("");
    const dispatch = useDispatch();
    const history = useHistory();
    const checkedOptionValue = '-1';

    const rootProps = useSelector((rootState: RootState) => {
        const isConnecting = serviceLoading(rootState, [CONNECT_DEALER_TO_ENGINE_API_REQUEST]);
        return {
            connect: rootState.dealers.connectByLabel.connect,
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            searchResults: rootState.dealers.connectByLabel.searchResults,
            isConnecting
        }
    }, shallowEqual);

    const radioButtonListItems = parseLocationToRadioButtonListItems(rootProps.searchResults?.locations);

    return (
        <Box>
            <BoxTitle>
                Connect your account with Google Business Profile to get started
            </BoxTitle>
            <Indication>
                {rootProps.searchResults?.locations.length} locations found. Please select the primary location associated with this name.
            </Indication>
            <Radio>
                <RadioButtonList 
                    name="rblLocations" 
                    RadioButtonListItems = {radioButtonListItems}
                    onSelectedItem = {(selectedValue) => setbusinessAccountID(selectedValue)} 
                />
            </Radio>
            <InlineRight>
            <ActionBar
                    mainActionLabel={"CONNECT"}
                    secondaryActionLabel={"CANCEL"}
                    onMainActionClick={() => dispatch(connectDealerToEngineAPI('GMB', rootProps.dealerId, businessAccountID))}
                    onSecondaryActionClick={() => dispatch(cleanSearchResults())}
                    mainActionDisabled={businessAccountID == "" ? true : false}
                    mainActionLoading={rootProps.isConnecting ? true : false}
                />
            </InlineRight>
        </Box>
    )

}

export default ResultsListingsBox